/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import { track } from '@coursera/event-pulse/sdk';

import MobileButton from 'bundles/composable-page-header/components/mobile-menu-items/MobileButton';
import { MOBILE_MAIN_IDENTIFIER } from 'bundles/composable-page-header/constants';
import { useMobileToSubPage } from 'bundles/composable-page-header/contexts/MobileNavigationContext';

import _t from 'i18n!nls/composable-page-header-enterprise';

const styles = {
  exploreButton: css`
    margin-top: var(--cds-spacing-100);
  `,
};
const EnterpriseExploreMenuItem = () => {
  const toSubPage = useMobileToSubPage();

  return (
    <MobileButton
      css={styles.exploreButton}
      label={_t('Explore')}
      name="explore"
      ariaLabel={_t('Explore all catalog')}
      trackingName="mobile_header_explore_button"
      onButtonClick={() => {
        track('open_navigation_menu', {
          navigationType: 'megamenu',
        });
        toSubPage?.(MOBILE_MAIN_IDENTIFIER.EXPLORE_MENU);
      }}
    />
  );
};

export default EnterpriseExploreMenuItem;
